<template>
    <div>
        <div class="top-content col-xs-12 consumer-duty">
            <div class="summary-top-bar">
                <div class="left">
                    Consumer Duty
                </div>
                <div class="right">
                    <form method="GET" :action="`/${path}/consumer-duty`">
                        <input type="text" name="search" placeholder="Search" v-model="searchQuery">

                        <button type="submit" class="btn btn-secondary" v-on:click="onSearch">Search</button>
                    </form>
                </div>
                <div style="clear:both"></div>
            </div>
            <table v-if="users.length > 0" class="table table-responsive">
                <tbody>
                    <tr v-for="user in users">
                        <td>
                            <a v-on:click="showReport(user.client_id)" style="cursor:pointer">
                                {{ user.first_name + ' ' + user.last_name }}
                            </a>
                        </td>
                    </tr>
                </tbody>
            </table>

        </div>
        <div v-if="showReportModal" class="consumer-duty-modal" v-on:click="closeReportModal">
            <section class="modal-body" v-on:click.stop>
                <!-- close -->
                <div class="close" v-on:click="closeReportModal">
                    <i class="fa fa-times"></i>
                </div>
                <!-- close -->
                <!-- header -->
                <div class="heading">
                    <h1>MO Consumer Duty data analytics dashboards</h1>
                    <span v-if="path === 'iress'">The FCA is now a data led regulator and wants firms to employ metrics and
technology so they gain and can report on all the relevant data and management
information to evidence good client outcomes. MO®s integration with IRESS
provides dashboards that provide the data analytics required for firms to evidence they
comply and provide an overview of available client data and scores each area against the
four Consumer Duty outcomes. The results will enable better quality data reports, gap
analysis and a good practice audit trail.</span>
                  <span v-if="path === 'io'">The FCA is now a data led regulator and wants firms to employ metrics and
technology so they gain and can report on all the relevant data and management
information to evidence good client outcomes. MO®s integration with intelliflo office
provides dashboards that provide the data analytics required for firms to evidence they
comply and provide an overview of available client data and scores each area against the
four Consumer Duty outcomes. The results will enable better quality data reports, gap
analysis and a good practice audit trail.</span>
                </div>
                <div class="content" v-if="!reportLoading">
                    <div class="top-header-row">
                      <div class="color-legend">
                        <div class="legend-item">
                          <div class="color" v-bind:style="getScoreStyle(0)"></div>
                          <div class="title">Missing Value</div>
                        </div>
                        <div class="legend-item">
                          <div class="color" v-bind:style="getScoreStyle(10)"></div>
                          <div class="title">Low Value</div>
                        </div>
                        <div class="legend-item">
                          <div class="color" v-bind:style="getScoreStyle(50)"></div>
                          <div class="title">Medium Value</div>
                        </div>
                        <div class="legend-item">
                          <div class="color" v-bind:style="getScoreStyle(100)"></div>
                          <div class="title">High Value</div>
                        </div>
                        <a v-on:click="refreshDataByClient" style="cursor:pointer">
                          <strong>Refresh</strong>
                        </a>
                        <!-- print -->
                        <div style="margin-left: 15px">
                          <i v-if="printInProcess" class="fa fa-spinner fa-spin"></i>
                          <i v-else class="fa fa-print" v-on:click="printPage"></i>
                        </div>
                        <!-- print -->
                      </div>
                      <div class="disclaimer">
                        <div class="disclaimer-title"><strong><a href="#" v-on:click="toggleDisclaimer">Disclaimer</a></strong></div><div class="disclaimer-content" v-if="showDisclaimer">The RAG scores are based on the quality of available data in each data field.
                          They provide guidance on the data value quality and allow firms to benchmark and improve
                          the quality of their data against the consumer duty client good outcomes objectives across
                          the four outcomes.
                        </div>
                      </div>
                    </div>

                    <div v-if="currentReport">
                      <consumer-duty-current-report-component :report="JSON.stringify(currentReport)"></consumer-duty-current-report-component>
                    </div>
                </div>
                <div v-else class="content-loading">
                    <div class="loader">
                        <div class="bar"></div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
//import debounce from 'lodash/debounce';
import ConsumerDutyCurrentReportComponent from "./ConsumerDutyCurrentReportComponent.vue";
import { printPage } from '../utils/printUtil.js';

export default {
  name: "ConsumerDutyComponent",
  components: {ConsumerDutyCurrentReportComponent},
  props: {
      search: {
        type: String,
        default: '',
      },
      path: {
        type: String,
        default: 'io'
      }
    },
    data() {
        return {
            usersLoading: false,
            reportLoading: false,
            users: [],
            searchQuery: '',
            reports: {},
            currentReport: null,
            showReportModal: false,
            showDisclaimer: false,
            selectedUser: null,
            printInProcess: false,
        }
    },
    mounted() {
        let urlParams = this.getHistoryUrlParams(window.location.href);
        if (urlParams.search) {
            let search = urlParams.search;
            this.searchQuery = search;
            this.getUsers(search);
        }
    },
    watch: {
        currentReport: function (val) {
            console.log(val);
        },
        /* searchQuery: debounce(function (val) {
            this.setHistoryUrlParams({search: val});
            this.getUsers(val);
        }, 500) */
    },
    methods: {
        onSearch() {
            this.setHistoryUrlParams({ search: this.searchQuery });
            this.getUsers(this.searchQuery);
        },
        getUsers(searchQuery = '') {
            if (!this.usersLoading) {
                this.usersLoading = true;
                axios.get(`/${this.path}/consumer-duty/users`, {
                    params: {
                        search: searchQuery,
                    }
                }).then(response => {
                    this.users = response.data;
                }).catch(error => {
                    console.log(error);
                }).finally(() => this.usersLoading = false);
            }
        },
        showReport(userId) {
          this.selectedUser = userId;
            if (!this.reportLoading) {
                this.showReportModal = true;
                if (!this.reports[userId]) {
                    this.reportLoading = true;
                    return axios.get(`/${this.path}/consumer-duty/report/` + userId)
                        .then(response => {
                            this.reports[userId] = response.data;
                            this.currentReport = this.reports[userId];
                        })
                        .catch(error => {
                            console.log(error);
                        })
                        .finally(() => this.reportLoading = false);
                } else {
                    this.currentReport = this.reports[userId];
                }

            }
        },
        toggleDisclaimer() {
            this.showDisclaimer = !this.showDisclaimer;
        },
        getHistoryUrlParams: function (url, asObject = true) {
            let paramsString = (url + '?').split('?')[1];

            if (asObject) {
                let params = {};
                paramsString.split('&').forEach(function (pair) {
                    pair = (pair + '=').split('=').map(decodeURIComponent);
                    if (pair[0].length) {
                        params[pair[0]] = pair[1];
                    }
                });
                return params;
            }
            return paramsString;
        },
        setHistoryUrlParams: function (params) {
            let urlParamsString = this.getHistoryUrlParams(window.location.href, false);

            Object.keys(params).forEach(function (key) {
                let re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
                let separator = urlParamsString ? (urlParamsString.match(re) ? "&" : "&") : "?";
                urlParamsString = urlParamsString.replace(re, '$1' + key + "=" + params[key] + '$2');
                if (!urlParamsString.match(re)) {
                    urlParamsString += separator + key + "=" + params[key];
                }
            });

            history.pushState({ name: 'consumer-duty' }, '', `/${this.path}/consumer-duty?` + urlParamsString);
        },

        getScoreStyle: function (score) {
            let color = '#2ECC71';
            let border = 'transparent';
            if (score == 0) {
                border = '#81c6e9';
                color = 'transparent';
            } else if (score < 34) {
                color = '#DE301D';
            } else if (score < 68) {
                color = '#F1C40F';
            }

            return {
                backgroundColor: color,
                borderColor: border
            };
        },

        closeReportModal() {
            this.showReportModal = false;
            this.currentReport = null;
            this.selectedUser = null;
        },

        refreshDataByClient() {
          this.currentReport = null;
          this.reportLoading = false;
          this.reports[this.selectedUser] = null
          this.showReport(this.selectedUser);
        },

        printPage() {
          this.printInProcess = true;
          const url = `/io/consumer-duty/report-print/${this.selectedUser}`;
          printPage(url, () => {
            this.printInProcess = false;
          });
        },
    }
}
</script>

<style scoped>
:not(.input-group-btn) > .btn-refresh-data {
  padding: 8px 8px;
  border-radius: 0;
}
</style>